export default ['/auth/idsign'];
